'use client';

import * as DS from '@aurorasolar/ds';
import { useCallback } from 'react';

import { useTracking } from '@/analytics';
import { PostSummary } from '@/app/home-solar/blog/actions';
import { TRACKING } from '@/helpers/tracking';

import { SlideshowPostList } from './SlideshowPostList';

type Props = { posts: PostSummary[]; subtitle?: string; title?: string };

export const BlogSlideshow = ({ posts, subtitle, title }: Props) => {
  const { trackEvent } = useTracking();

  const handleNavigate = useCallback(
    (slug: string) => {
      trackEvent(TRACKING.BLOG_READ_MORE, { page: slug });
    },
    [trackEvent]
  );

  return (
    <DS.Flex maxW={DS.BorealisTheme.screens.xl} mx="auto" p={{ _: 6, lg: 10 }}>
      <DS.Flex gap={0}>
        <h2>{title}</h2>
        <div>{subtitle}</div>
      </DS.Flex>
      <DS.Divider />
      <SlideshowPostList onNavigate={handleNavigate} pageSize={3} posts={posts} size={{ _: 'full', md: 'third' }} />
    </DS.Flex>
  );
};
